import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Platform, StyleProp, StyleSheet, ViewStyle } from 'react-native';
import { Spacing } from '../../styles';
import { Colors } from '../../themes/colors';
import { Button } from '../crop-circle/Button';
import { SystemNotification } from '../system-notification';
import { BottomBar } from './bottomBar';
import { RestartButton } from './restartButton';
import { BottomComponentBarBaseProps } from './types';

export const BottomComponentBar = (props: BottomComponentBarBaseProps) => {
  const isWeb = Platform.OS === 'web';
  const left = props.left || props.backButton;
  const right = props.right ? (
    props.right
  ) : props.onRightPress ? (
    <RestartButton
      onPress={props.onRightPress}
      disabled={props.rightPressDisabled}
    />
  ) : undefined;

  const centerBlock =
    props.additionalHeaderBlock ||
    (props.onSave ? (
      <SaveButton
        onPress={() => props.onSave?.()}
        disabled={props.rightPressDisabled}
        label={props.saveLabel}
        fontSize={!isWeb ? 14 : undefined}
        style={[styles.baseButton, styles.addButton]}
      />
    ) : undefined);

  return (
    <>
      <BottomBar
        style={props.style}
        left={left}
        right={right}
        additionalHeaderBlock={centerBlock}
      />
      <SystemNotification />
    </>
  );
};

type SaveButtonProps = {
  onPress: () => void;
  disabled?: boolean;
  style?: StyleProp<ViewStyle>;
  label?: string;
  isLoading?: boolean;
  activeTextColor?: string;
  fontSize?: number;
};

const SaveButton: FC<SaveButtonProps> = (props: SaveButtonProps) => {
  const { t } = useTranslation();
  const state = props.disabled ? 'default' : 'active';

  return (
    <Button
      onPress={props.onPress}
      style={styles.saveButtonContainer}
      state={state}
      disabled={props.disabled}
    >
      {props.label || t('topNav.save')}
    </Button>
  );
};

const styles = StyleSheet.create({
  baseButton: {
    width: 56,
    height: 56,
    maxHeight: 56,
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    borderRadius: 8,
    marginRight: Spacing.baseMargin.base,
  },
  addButton: {
    backgroundColor: Colors.grayDivider,
  },
  saveButtonContainer: {
    flex: 1,
    height: 56,
    maxHeight: 56,
  },
});
